import { j as s } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as o } from "react";
import { I as i } from "../../../../IconBase-CxZyIWw2.js";
const l = o((r, a) => /* @__PURE__ */ s.jsx(
  i,
  {
    ref: a,
    ...r,
    image: (e) => /* @__PURE__ */ s.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...e,
        children: [
          /* @__PURE__ */ s.jsx(
            "mask",
            {
              id: "mask0_2974_3676",
              width: 16,
              height: 16,
              x: 0,
              y: 0,
              maskUnits: "userSpaceOnUse",
              style: {
                maskType: "alpha"
              },
              children: /* @__PURE__ */ s.jsx("path", { fill: "currentColor", d: "M0 0h16v16H0z" })
            }
          ),
          /* @__PURE__ */ s.jsxs("g", { fill: "currentColor", mask: "url(#mask0_2974_3676)", children: [
            /* @__PURE__ */ s.jsx("path", { d: "M13.19 0c-.41 0-.75.34-.75.75V14.5H3.5V.75C3.5.34 3.16 0 2.75 0S2 .34 2 .75v14.04c0 .67.54 1.21 1.2 1.21h9.54c.66 0 1.2-.54 1.2-1.21V.75c0-.41-.34-.75-.75-.75" }),
            /* @__PURE__ */ s.jsx("path", { d: "M5.1 3.94h5.74c.22 0 .43-.1.58-.27.14-.17.2-.4.16-.61L11.14.62A.76.76 0 0 0 10.4 0H5.54c-.36 0-.67.26-.74.62l-.44 2.44c-.04.22.02.44.16.61.15.17.36.27.58.27M6.17 1.5h3.6l.17.94H6z" })
          ] })
        ]
      }
    )
  }
));
l.displayName = "AgencyClipboardIcon";
export {
  l as AgencyClipboardIcon,
  l as default
};
//# sourceMappingURL=index.js.map
